import { gql } from "@apollo/client";
import { assetData, assetHierarchyLevel, assetHierarchy } from "./fragments";

export const ENGINE_TYPES_QUERY = gql`
  query engineTypes {
    engineTypes {
      code
      name
    }
  }
`;

export const REGISTRATION_TYPES_QUERY = gql`
  query registrationTypes($insuranceTypeId: Int!) {
    registrationTypes(insuranceTypeId: $insuranceTypeId) {
      id
      code
      name
      implicit
    }
  }
`;

export const ASSET_CATEGORY_QUERY = gql`
  query assetCategory($id: Int!) {
    assetCategory(id: $id) {
      id
      name
    }
  }
`;

export const ASSET_CATEGORIES_QUERY = gql`
  query assetCategories($insuranceTypeCode: String!, $assetTypeCode: String) {
    assetCategories(insuranceTypeCode: $insuranceTypeCode, assetTypeCode: $assetTypeCode) {
      id
      name
      implicit
      minSeatsNumber
      maxSeatsNumber
      minWeight
      maxWeight
    }
  }
`;

export const ASSET_SUBCATEGORY_QUERY = gql`
  query assetSubcategory($id: Int!) {
    assetSubcategory(id: $id) {
      id
      name
    }
  }
`;

export const ASSET_SUBCATEGORIES_QUERY = gql`
  query assetSubcategories($categoryId: Int) {
    assetSubcategories(categoryId: $categoryId) {
      id
      name
      categoryId
      minWeight
      maxWeight
      minSeatsNumber
      maxSeatsNumber
    }
  }
`;

export const VEHICLE_CATEGORIES_QUERY = gql`
  query vehicleCategories {
    vehicleCategories {
      code
      name
    }
  }
`;

export const ASSET_HIERARCHY_QUERY = gql`
  query assetHierarchy($assetTypeId: Int, $searchInactive: Boolean) {
    assetHierarchy(assetTypeId: $assetTypeId, searchInactive: $searchInactive) {
      ...assetHierarchyLevel
    }
  }
  ${assetHierarchyLevel}
`;

export const ASSET_HIERARCHY_LEVEL_SOURCE_QUERY = gql`
  query assetHierarchyLevelSource($parentId: Int) {
    assetHierarchyLevelSource(parentId: $parentId) {
      level
      data {
        ...assetHierarchy
      }
    }
  }
  ${assetHierarchy}
`;

export const EQUIPMENT_QUERY = gql`
  query equipment {
    equipment {
      id
      name
    }
  }
`;

export const ASSET_QUERY = gql`
  query asset($assetId: Int!, $searchInactive: Boolean) {
    asset(assetId: $assetId, searchInactive: $searchInactive) {
      ...assetData
    }
  }
  ${assetData}
`;

export const RETRIEVE_ASSET_DATA_QUERY = gql`
  query retrieveAssetData($chassisNumber: String!, $insuranceTypeId: Int!) {
    retrieveAssetData(chassisNumber: $chassisNumber, insuranceTypeId: $insuranceTypeId) {
      assetData {
        assetId
        chassisNumber
        vehicleCategoryCode
        rcaCategoryId
        cascoCategoryId
        subcategoryId
        assetTypeId
        assetHierarchyId
        otherAssetName
        registrationTypeId
        registrationNumber
        engineType
        cylindricCapacity
        enginePower
        maxWeight
        seatsNumber
        manufacturingYear
        manufacturingMonth
        identityCardSeries
        currentMileage
        purchasePrice
        purchaseInvoiceDate
        firstRegistrationDate
        qtty
        equipment
        hierarchy {
          ...assetHierarchyLevel
        }
      }
      timeOut
    }
  }
  ${assetHierarchyLevel}
`;

export const CHECK_ACTIVE_OFFERS_BY_CHASSIS_NUMBER = gql`
  query checkActiveOffersExistence(
    $documentId: Int!
    $chassisNumber: String!
    $insuranceTypeId: Int!
    $startDate: DateTime
  ) {
    checkActiveOffersExistence(
      documentId: $documentId
      chassisNumber: $chassisNumber
      insuranceTypeId: $insuranceTypeId
      startDate: $startDate
    )
  }
`;
